import { createResource, type RouteResource } from 'react-resource-router';

import { getIsCurrentSiteSyncEnabled } from './endpoints';

// This resource is an opt-in resource, so null can be expected when the resource is not used.
export const isCurrentSiteSyncEnabledResource: RouteResource<boolean | null> = createResource<
	boolean | null
>({
	type: 'isCurrentSiteSyncEnabledResource',
	getKey: () => `isCurrentSiteSyncEnabledResource`,
	getData: getIsCurrentSiteSyncEnabled,
	maxAge: 5 * 60 * 1000, // 5 mins
	isBrowserOnly: true,
});
